import { Toast, type ToastProps } from "@/marketplace/toast/Toast";
import { useCallback, useState } from "react";

type ToastState = Omit<ToastProps, "onDismiss">;

/** @temporary Replace with MetX design system toast once available. */
export function useMarketplaceToast() {
  const [toast, setToast] = useState<ToastState | null>(null);
  const dismiss = useCallback(() => setToast(null), []);

  return {
    showToast: (nextToast: ToastState) => setToast(nextToast),
    toast: toast ? <Toast {...toast} onDismiss={dismiss} /> : null,
  };
}
